import styled from "styled-components";
import Movement from "../contentSections/Movement";
import Sensors from "../contentSections/Sensors";
import Data from "../contentSections/Data";
import Visualization from "../contentSections/Visualization";
import Interpretation from "../contentSections/Interpretation";
import Sonification from "../contentSections/Sonification";

import { LoopSectionName } from "./LoopSection";
import { accentColor, bodyTextBold, bodyTextRegular } from "./style";
import { useEffect, useRef } from "react";
import { breakpoint } from "./style";

const FullScreenContainerDiv = styled.div`
    position: fixed;
    top: 0px;
    height: 100vh;
    z-index: 5000;
    background-color: #FFFFFF;
    border-left: 1px solid #FFFFFF;
    left: 0;
    width: 100%;
    opacity: 0;
    display: flex;
    flex-direction: column;

    transition: left 0.5s, opacity 0.5s;
    transition-timing-function: ease;

    &.open {
        opacity: 1;
        pointer-events: all;
    }

    &.closed {
        opacity: 0;
        pointer-events: none;
    }

`;

const FullScreenContainerHeader = styled.h1`
    ${bodyTextBold}
    font-size: 16pt;
    width: 100%;
    border-bottom: 1px solid #CECECE;
    margin: 0px 0px 0px 0px;
    padding: 0px 20px 10px 60px;


    @media ${breakpoint.phone} {
        padding: 0px 20px 10px 20px;
    }

`;

const CloseTab = styled.div`
    ${bodyTextRegular}
    margin: 0px;
    margin-left: 60px;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 0px;
    cursor: pointer;
    color: #333333;
    font-size: 12pt;

    &:hover {
        ${bodyTextBold}
    }

    @media ${breakpoint.phone} {
        margin-left: 20px;
    }
`;

export const FullScreenContentContainer = styled.section`
    ${bodyTextRegular};

    flex: 1;
    padding: 20px 20% 100px 100px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    & p {
        font-size: 16pt;
        line-height: 30pt;
        border-left: 1px solid #e0e0e0;
        padding-left: 40px;
        position: relative;
        margin: 40px 0px;
    }

    & p:after {
        position: absolute;
        left: -5px;
        bottom: -25px;
        width: 10px;
        height: 10px;
        content: "";
        border-radius: 5px;
        background-color: #e0e0e0;
    }

    @media ${breakpoint.laptop} {
        padding: 20px 10% 40px 40px;
    }

    @media ${breakpoint.phone} {

        padding: 20px 10% 40px 20px;

        & p {
            font-size: 14pt;
            line-height: 22pt;
            padding-left: 20px;        
        }


    }



`;

const TitleSpan = styled.span`
    display: inline-block
    margin-right: 10px;
    cursor: pointer;

    color: #a0a0a0;

    &.highlighted {
        color: ${accentColor};
    }

    &:not(:last-of-type):after {
        display: inline-block;
        margin-left: 10px;
        margin-right: 10px;
        content: "→";
    }

    &:hover {
        text-shadow: 2px 2px 3px #e0e0e0;
    }
`;

const FullScreenContainer = ({whichSectionToView, setWhichSectionToView,showFullScreenContainer, setShowFullScreenContainer, setSectionIsExpanded}) => {
    let sectionContent;
    let sectionTitle;

    const fullScreenContainerRef = useRef(null);
    useEffect(() => {
        if(fullScreenContainerRef && fullScreenContainerRef.current) {
            fullScreenContainerRef.current.scrollTo(0, 0);
        }

    }, [fullScreenContainerRef, whichSectionToView])


    sectionTitle = <>
        <TitleSpan className={whichSectionToView === LoopSectionName.Movement ? "highlighted" : ""} onClick={() => setWhichSectionToView(LoopSectionName.Movement)}>Movement</TitleSpan>
        <TitleSpan className={whichSectionToView === LoopSectionName.Sensors ? "highlighted" : ""} onClick={() => setWhichSectionToView(LoopSectionName.Sensors)}>Sensors</TitleSpan>
        <TitleSpan className={whichSectionToView === LoopSectionName.Data ? "highlighted" : ""} onClick={() => setWhichSectionToView(LoopSectionName.Data)}>Data</TitleSpan>
        <TitleSpan className={whichSectionToView === LoopSectionName.Visualization ? "highlighted" : ""}  onClick={() => setWhichSectionToView(LoopSectionName.Visualization)}>Visualization</TitleSpan>
        <TitleSpan className={whichSectionToView === LoopSectionName.Interpretation ? "highlighted" : ""}  onClick={() => setWhichSectionToView(LoopSectionName.Interpretation)}>Interpretation</TitleSpan>
        <TitleSpan className={whichSectionToView === LoopSectionName.Sonification ? "highlighted" : ""}  onClick={() => setWhichSectionToView(LoopSectionName.Sonification)}>Sonification</TitleSpan>
        </>; 

    if(whichSectionToView === LoopSectionName.Movement) {
        sectionContent = <Movement setWhichSectionToView={setWhichSectionToView} />;
    } else if(whichSectionToView === LoopSectionName.Sensors) {
        sectionContent = <Sensors setWhichSectionToView={setWhichSectionToView} />;
    } else if(whichSectionToView === LoopSectionName.Data) {
        sectionContent = <Data setWhichSectionToView={setWhichSectionToView} />;
    } else if(whichSectionToView === LoopSectionName.Visualization) {
        sectionContent = <Visualization setWhichSectionToView={setWhichSectionToView} />;

    } else if(whichSectionToView === LoopSectionName.Interpretation) {
        sectionContent = <Interpretation setWhichSectionToView={setWhichSectionToView} />;


    } else if(whichSectionToView === LoopSectionName.Sonification) {
        sectionContent = <Sonification handleClose={() => { setShowFullScreenContainer(false); setSectionIsExpanded(false); }}/>;

    }

    return <FullScreenContainerDiv ref={fullScreenContainerRef} className={showFullScreenContainer == true ? "open" : "closed"}>
        <CloseTab onClick={() => {
            setShowFullScreenContainer(false);
            setSectionIsExpanded(false);
        }}>✕ Close and return to previous</CloseTab>
        <FullScreenContainerHeader>{sectionTitle}</FullScreenContainerHeader>
        {sectionContent}
    </FullScreenContainerDiv>

}

export default FullScreenContainer;
